import moment from 'moment';
import { Row } from 'react-table';
import { CountryFlag } from 'CountryFlag/CountryFlag';
import i18n from 'resources/i18n';

import { AreaTargetCatalogEntryInfo } from 'ais-facade-api/api';

import styles from './VesselsCatalogModal.module.scss';
import { Link } from 'react-router-dom';
import { useFormatMoment } from 'app/hooks/useFormatMoment';
import { Icon, VesselIcon } from 'app/components';

export const vesselsCatalogModalColumns = [
  {
    Header: <Icon name="s-ais" size="20px" color="#fff" />,
    accessor: 'type',
    width: 34,
    minWidth: 34,
    maxWidth: 34,
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => {
      return (
        <div className={styles.center_icon_cell}>
          <VesselIcon vessel={vessel} />
        </div>
      );
    },
  },
  {
    Header: 'MMSI',
    accessor: 'mmsi',
    cellClassName: `${styles.link}`,
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) =>
      typeof vessel.mmsi === 'number' ? (
        <Link to={`/vessels/${vessel.mmsi}`} target="_blank" className={styles.link}>
          {vessel.mmsi}
        </Link>
      ) : (
        <>&mdash;</>
      ),
    canSort: true,
    sortBy: 'MMSI',
    width: 50,
  },
  {
    Header: 'Name',
    accessor: 'staticData?.name',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.registryData?.name === 'string' ? (
          vessel.registryData.name
        ) : typeof vessel.staticData?.name === 'string' ? (
          vessel.staticData.name
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
    sortBy: 'NAME',
    width: 120
  },
  {
    Header: 'IMO',
    accessor: 'staticData?.imo',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.registryData?.imo === 'number' ? (
          vessel.registryData.imo
        ) : typeof vessel.staticData?.imo === 'number' ? (
          vessel.staticData.imo
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
    sortBy: 'IMO',
    width: 80,
  },
  {
    Header: 'CallSign',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.registryData?.callSign === 'string' ? (
          vessel.registryData.callSign
        ) : typeof vessel.staticData?.callSign === 'string' ? (
          vessel.staticData.callSign
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'Flag',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>
        {vessel?.meta?.countryName ? (
          <>
            {vessel.meta.countryCode && <CountryFlag countryCode={vessel.meta.countryCode?.toLocaleLowerCase()} />}
            {vessel.meta.countryName} ({vessel.meta.countryCode})
          </>
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    width: 120
  },
  {
    Header: 'Type',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>{vessel.meta && vessel.meta.typeGroup ? vessel.meta.typeGroup : <>&mdash;</>}</>
    ),
    width: 120
  },
  {
    Header: 'NavStatus',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>{typeof vessel?.meta?.status === 'string' ? vessel.meta.status : <>&mdash;</>}</>
    ),
    width: 150,
    maxWidth: 150,
    minWidth: 150
  },
  {
    Header: 'Destination',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>{vessel.voyage?.destination ? vessel.voyage.destination : <>&mdash;</>}</>
    ),
    width: 200
  },
  {
    Header: 'Course',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>{typeof vessel?.position?.cog === 'number' ? <>{vessel.position.cog}&deg;</> : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'Speed',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.position?.sog === 'number' ? (
          vessel.position.sog.toFixed(2) + ` ${i18n.t('VesselSpeedUnit')}`
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'DataObtained',
    Cell: ({ row: { original: vessel } }: { row: Row<AreaTargetCatalogEntryInfo> }) => {
      const formatMoment = useFormatMoment();

      return <>{vessel.t ? formatMoment(moment(vessel.t)) : <>&mdash;</>}</>;
    },
    canSort: true,
    sortBy: 'RECEIVED_DATE',
    width: 145
  },
];
